//
//
//
//
//
//
//
//

import ModalActionsContainer from '~/components/Shared/ModalActionsContainer.vue'
export default {
  components: {
    ModalActionsContainer,
  },
}
